module.exports = __webpack_public_path__ + "img/视频封面17.6abceb0f.png";